const details = {
    name: "فروشگاه متین تویز",
    enName: "shop",
    description: "فروشگاه متین تویز",
    supportDescription: "",
    workingHours: [],
    "__choose among these__": "",
    enamadTag: "",
    samandehiTag: "",
    ZarinpalLink: "https://www.zarinpal.com/webservice/TrustCode",
    developmentCompanyWebsite: {
        name: "شرکت توسعه و طراحی سایت باران",
        link: "https://barantm.com"
    },
    meta: {
        title: "کرج هابی - متین تویز فروشگاه آنلاین اسباب بازی و انواع پهباد",
        description: 'ارائه دهنده اسباب بازی مناسب همه سنین و لوازم سرور، موتور ها، شارژر و باطری ها',
        canonical: 'https://karajhobby.com',
        locale: 'fa-IR',
        link: "https://karajhobby.com"
    }
}

export default details;
